import { useRef } from 'react';
import { createLabel, updateLabel } from '../../services/labelService';
import { useLocation } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import {
  errorMessageAtom,
  successMessageAtom,
} from '../../atoms/messageBarAtoms';
import { EditItem } from '@moko/ui';

const LabelValue = () => {
  const isSaved = useRef(false);
  const query = new URLSearchParams(useLocation().search);
  const labelSet = query.get('labelSet') ?? '';
  const labelId = Number.parseInt(query.get('id') ?? '');
  const setSuccessMessage = useSetAtom(successMessageAtom);
  const setErrorMessage = useSetAtom(errorMessageAtom);

  const isEdit = !isNaN(labelId) && labelId > 0;

  const defaultValues = isEdit
    ? JSON.stringify({
        labelSet,
        key: query.get('key') ?? '',
        label: query.get('label') ?? '',
      })
    : JSON.stringify({ labelSet });

  return (
    <>
      <div>Label</div>
      <EditItem
        getAction={async () => {
          return {
            labelSet,
            key: query.get('key') ?? '',
            label: query.get('label') ?? '',
          };
        }}
        newAction={async (abortController, newLabel) => {
          const nextLabelSet = (newLabel.labelSet as string)?.trim();
          const nextKey = (newLabel.key as string)?.trim();
          const nextLabel = (newLabel.label as string)?.trim();
          if (!nextLabelSet || !nextKey || !nextLabel) {
            setErrorMessage('Label Set, Key and Value are required.');
            return;
          }
          const createResponse = await createLabel(abortController, {
            labelSet: nextLabelSet,
            key: nextKey,
            label: nextLabel,
          });
          setSuccessMessage(
            `Label with id: ${createResponse.labelId} created.`
          );
        }}
        editAction={async (abortController, _id, editedLabel) => {
          await updateLabel(abortController, labelId, {
            labelSet: editedLabel.labelSet as string,
            key: editedLabel.key as string,
            label: editedLabel.label as string,
            isDeleted: false,
          });
          setSuccessMessage(`Label with id: ${labelId} successfully updated.`);
        }}
        isSaved={isSaved}
        back={'/settings/labels'}
        defaultValues={defaultValues}
        metadata={{
          fields: [
            {
              name: 'labelSet',
              fieldType: 'String',
              label: 'Label Set',
              readonly: isEdit,
              mandatory: true,
              maxLength: 10,
            },
            {
              name: 'key',
              fieldType: 'String',
              label: 'Key',
              mandatory: true,
            },
            {
              name: 'label',
              fieldType: 'String',
              label: 'Value',
              mandatory: true,
            },
          ],
          lookups: [],
          validations: [],
          interactions: [],
        }}
      />
    </>
  );
};

export default LabelValue;
